import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import api from '../../services/api';

// Piezas compartidas por los estados financieros (#110): selector de
// avisos de datos incompletos y descarga del Excel (el selector BCV/USD es
// el común de components/reportes/SelectorMoneda).

// `avisos`: lista de { texto, enlace? } ya filtrada (solo los que aplican).
export function Avisos({ avisos }) {
  if (!avisos.length) return null;
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 space-y-1 print:hidden">
      {avisos.map((a) => (
        <p key={a.texto} className="flex items-start gap-2">
          <AlertTriangle size={15} className="mt-0.5 shrink-0" />
          <span>
            {a.texto}
            {a.enlace && (
              <>
                {' '}
                <Link to={a.enlace.to} className="underline font-medium">{a.enlace.label}</Link>
              </>
            )}
          </span>
        </p>
      ))}
    </div>
  );
}

export async function descargarExcel(ruta, params, nombreArchivo) {
  const { data } = await api.get(ruta, { params, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Monto con signo en rojo si es negativo (formato ya aplicado afuera).
export function claseMonto(valor) {
  return Number(valor) < 0 ? 'text-red-600' : '';
}
